/*
 * Sportsact: pris på "Tilføj til kurv" (snippets/custom-atc-price.liquid) – hovedknap og sticky-bar.
 * Uden mængderabat: variantpris × antal. Med mængderabat: det valgte trins pris fra <custom-quantity-breaks>
 * (antal × pris − rabat, samme data som vælgeren – assets/custom-quantity-breaks.js).
 */
(() => {
  if (customElements.get('custom-atc-price')) return;

  class CustomAtcPrice extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      try {
        this.data = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
      } catch (e) {
        return;
      }

      this.formId = this.getAttribute('form');
      this.form = document.getElementById(this.formId);
      if (!this.form) return;

      this.variantId = this.form.querySelector('[name="id"]')?.value;
      const schedule = () => this.schedule();

      this.form.addEventListener('variant:change', (event) => {
        this.variantId = event.detail.variant?.id ?? this.variantId;
        // Efter Impact og sticky-baren har opdateret deres knapper
        setTimeout(schedule, 60);
      });

      this.form.addEventListener('input', schedule);
      this.form.addEventListener('change', schedule);
      this.form.addEventListener('quantity-breaks:change', schedule);
      document.addEventListener('click', (event) => {
        if (event.target.closest('quantity-selector')) setTimeout(schedule, 60);
      });

      // Impact og sticky-baren genskriver knapperne uden events: reagér på ændringer
      const observer = new MutationObserver(schedule);
      document.querySelectorAll('.product-info__buy-buttons, custom-sticky-atc').forEach((node) => {
        observer.observe(node, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled'] });
      });

      this.schedule();
    }

    schedule() {
      clearTimeout(this._timer);
      this._timer = setTimeout(() => this.render(), 30);
    }

    format(cents) {
      const hasDecimals = cents % 100 !== 0;
      const amount = new Intl.NumberFormat('da-DK', {
        minimumFractionDigits: hasDecimals ? 2 : 0,
        maximumFractionDigits: 2,
      }).format(cents / 100);
      return (this.data.money_format || '{{amount}} kr').replace(/\{\{\s*\w+\s*\}\}/, amount);
    }

    // Beløb i øre, eller null når det ikke kan fastslås sikkert
    computeCents() {
      const breaks = document.querySelector(`custom-quantity-breaks[form="${this.formId}"]`);
      if (breaks && !breaks.hidden && typeof breaks.totalCents === 'function') {
        return breaks.totalCents();
      }

      const unit = this.data.variants[String(this.variantId)];
      if (typeof unit !== 'number') return null;

      const quantity = parseInt(this.form.querySelector('[name="quantity"]')?.value, 10) || 1;
      return unit * quantity;
    }

    setPrice(container, text) {
      if (!container) return;
      let span = container.querySelector('.custom-atc-price');

      if (!text) {
        span?.remove();
        return;
      }

      if (!span) {
        span = document.createElement('span');
        span.className = 'custom-atc-price';
        container.append(span);
      }

      if (span.textContent !== text) span.textContent = text;
    }

    render() {
      const mainButton = document.querySelector(`.product-info__buy-buttons buy-buttons[form="${this.formId}"] button[type="submit"]`);
      const stickyLabel = document.querySelector('.custom-sticky-atc__button-label');
      const cents = mainButton && !mainButton.disabled ? this.computeCents() : null;
      const text = cents === null ? '' : ` • ${this.format(cents)}`;

      this.setPrice(mainButton?.querySelector(':scope > div') || mainButton, text);
      this.setPrice(stickyLabel, text);
    }
  }

  customElements.define('custom-atc-price', CustomAtcPrice);
})();
